import React from 'react';
import { Row, Col, Card, Badge, Typography, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './Clients.css';

const { Title, Text } = Typography;

const WhiteLabelClients = () => {
  const navigate = useNavigate();

  const clients = [
    {
      id: 1,
      name: 'ProShine Auto Detailing',
      email: 'marie@proshinedetail.com',
      locations: 1,
      vehicles: 5,
      activeCampaigns: 2,
      mrr: '$733',
      commission: '$293.2/mo',
      status: 'active'
    },
    {
      id: 2,
      name: 'Blue Ridge HVAC',
      email: 'james@blueridgehvac.com',
      locations: 3,
      vehicles: 18,
      activeCampaigns: 3,
      mrr: '$2,206',
      commission: '$882.4/mo',
      status: 'active'
    }
  ];

  const handleViewDashboard = (clientId) => {
    navigate(`/whitelabel/clients/${clientId}/dashboard`);
  };

  return (
    <div className="reseller-clients">
      {/* Header */}
      <div className="clients-header">
        <div>
          <Title level={2} style={{ margin: 0 }}>Client Management</Title>
          <Text type="secondary">ServiceTech Marketing Partners</Text>
        </div>
        <div className="last-updated">Last updated: 7:28:30 PM</div>
      </div>

      {/* Page Title */}
      <div className="page-title-section">
        <Title level={3} style={{ margin: 0 }}>Client Management</Title>
        <Text type="secondary">View details and manage your assigned clients</Text>
      </div>

      {/* Client Cards */}
      <Row gutter={[24, 24]}>
        {clients.map((client) => (
          <Col xs={24} lg={12} key={client.id}>
            <Card className="client-card">
              <div className="client-card-header">
                <div>
                  <Title level={4} style={{ margin: 0 }}>{client.name}</Title>
                  <Text type="secondary">{client.email}</Text>
                </div>
                <Badge status="success" text="active" />
              </div>

              <div className="client-stats">
                <Row gutter={16}>
                  <Col span={12}>
                    <div className="stat-item">
                      <Text type="secondary">Locations</Text>
                      <div className="stat-value">{client.locations}</div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="stat-item">
                      <Text type="secondary">Vehicles</Text>
                      <div className="stat-value">{client.vehicles}</div>
                    </div>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginTop: 16 }}>
                  <Col span={12}>
                    <div className="stat-item">
                      <Text type="secondary">Active Campaigns</Text>
                      <div className="stat-value">{client.activeCampaigns}</div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="stat-item">
                      <Text type="secondary">MRR</Text>
                      <div className="stat-value">{client.mrr}</div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="commission-section">
                <Text type="secondary">Your Commission</Text>
                <div className="commission-value">{client.commission}</div>
              </div>

              <Button 
                type="link" 
                icon={<EyeOutlined />}
                onClick={() => handleViewDashboard(client.id)}
                className="view-dashboard-btn"
              >
                View Enterprise Dashboard
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default WhiteLabelClients;
